module.exports = __webpack_public_path__ + "img/logo.662e066f.png";